package pl.finn.forms.model

import io.kvision.core.Component
import io.kvision.html.*
import io.kvision.html.Fieldset
import io.kvision.i18n.tr
import io.kvision.panel.FieldsetPanel
import io.kvision.panel.SimplePanel
import io.kvision.panel.Tab
import pl.finn.forms.generator.DocumentFormModel
import pl.finn.forms.utils.form.FormBuilder

class Fieldset(reference: FormBuilder<DocumentTreeNode>) {

  private val formReference = reference
  private var previousElement = DocumentTreeNode()
  private var buttonHiddenDiv = Div()
  private var elementNo = 0

  fun createFieldset(element: DocumentTreeNode, nestedElements: LinkedHashMap<DocumentTreeNode, Any>, previousElement: ArrayList<DocumentTreeNode?>): SimplePanel {
    var labelContent = getLabel(element)
    if (labelContent?.contains("<p style=\"display:none\"") == true) {
      val tag = "<p style=\"display:none\">"
      val subStart = labelContent.indexOf(tag)
      val subEnd = labelContent.indexOf("</p>")
      labelContent = labelContent.removeRange(subStart, subEnd)
    }
    val fieldset = FieldsetPanel() {
      this.legend = labelContent?.replace("<[^>]*>".toRegex(),"")
      if (!element.metaModel?.header.isNullOrEmpty()) add(H6(element.metaModel?.header, className = "h6", rich = true))
      nestedElements.forEach {
        add(it.value as Component)
      }
    }
    return (
        Div () {
          add(fieldset)
          if (element.metaModel?.particleView?.get(0)?.addButtonName != null) {
            shouldRenderButtonDiv(element)
            add(createButtonGroup(element, previousElement))
          }
        }
        )
  }

  fun createPillsTab(element: DocumentTreeNode, panel: Component): Tab {
    val labelContent = prepareTabLabel(element)
    return Tab(tr(labelContent ?: "Informacje szczegółowe")) {
      setAttribute("data-finn-toggle", "pill")
      add(panel)
    }
  }

  private fun prepareTabLabel(element: DocumentTreeNode): String {
    var rawLabel = getLabel(element)
    if (rawLabel?.contains("<p style") == true) {
      val tag = "<p style=\"display:none\">"
      val subStart = rawLabel.lastIndexOf(tag)
      val subEnd = rawLabel.indexOf("</p>")
      rawLabel = rawLabel.substring(subStart + tag.length, subEnd)
      return rawLabel.substring(0, 1).uppercase() + rawLabel.substring(1).lowercase()
    }
    val label = rawLabel?.split("\\s+".toRegex(), limit = 4)?.toMutableList()
    if (label?.get(0)?.contains('.') == true) {
      label[0] = ""
    }
    var result = ""
    var x = 0
    while (x < label?.size!!) {
      result += "${label[x].replace("^[^a-zA-Z]*|[^a-zA-Z]*$".toRegex(), "")} "
      x++
    }
    return result.substring(0, 1).uppercase() + result.substring(1).lowercase()
  }

  private fun createButtonGroup(
    element: DocumentTreeNode,
    parentElements: ArrayList<DocumentTreeNode?>,
  ): Div {
    val position = parentElements.indexOf(element) + 1
    return (
        Div(className = "p-2 d-flow-root") {
          buttonHiddenDiv = this

          if (elementNo > 1) {
            button(
              "Usuń",
              "far fa-minus-square",
              ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
            ).onClick {
              formReference.getData()
              parentElements.remove(element)
              DocumentFormModel.refreshForm()
            }
          }
          button(
            "Dodaj",
            "far fa-plus-square",
            ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
          ).onClick {
            formReference.getData()
            parentElements.add(position, prepareElementToSerialization(element))
            DocumentFormModel.refreshForm()
          }
        }
        )
  }

  @OptIn(ExperimentalStdlibApi::class)
  private fun prepareElementToSerialization(element: DocumentTreeNode): DocumentTreeNode {

    val id = element.id.dropLast(8) + getRandomString()
    val copiedChoiceList = ArrayList<DocumentTreeNode?>()
    element.children.forEach {
      copiedChoiceList.add(prepareElementToSerialization(it!!))
    }

    val metaModel = MetaModel(
      id,
    ).apply {
      controlType = element.metaModel?.controlType
      choiceView = element.metaModel?.choiceView
      enumValues = element.metaModel?.enumValues
      footer = element.metaModel?.footer
      footerClass = element.metaModel?.footerClass
      header = element.metaModel?.header
      headerClass = element.metaModel?.headerClass
      help = element.metaModel?.help
      html = element.metaModel?.html
      inputSize = element.metaModel?.inputSize
      label = element.metaModel?.label
      nodeName = element.metaModel?.nodeName
      nodeQName = element.metaModel?.nodeQName
      particleView = element.metaModel?.particleView
      validationMessage = element.metaModel?.validationMessage
      value = element.metaModel?.value ?: ""
      viewType = element.metaModel?.viewType
      isElementRequired = element.metaModel?.isElementRequired
      labelArray = element.metaModel?.labelArray
    }

    return DocumentTreeNode(
      id,
      element.name,
      element.type
    ).apply {
      children = copiedChoiceList
      choiceLabels = element.choiceLabels
      label = element.label
      namespace = element.namespace
      parent = element.parent
      typeName = element.typeName
      typeNamespace = element.typeNamespace
      value = ""
      maxOccurs = element.maxOccurs
      this.metaModel = metaModel
    }
  }

  private fun shouldRenderButtonDiv(element: DocumentTreeNode) {
    val label = if (!element.metaModel?.label.isNullOrEmpty()) element.metaModel?.label else element.label
    val previousLabel =
      if (!previousElement.metaModel?.label.isNullOrEmpty()) previousElement.metaModel?.label else previousElement.label
    if (previousLabel != null && previousLabel == label) {
      buttonHiddenDiv.hide()
      elementNo++
    } else if (elementNo > 0) {
      previousElement = element
      elementNo = 1
    } else {
      buttonHiddenDiv.hide()
      elementNo = 1
      previousElement = element
    }
  }

  private fun getLabel(element: DocumentTreeNode) =
    if (!element.metaModel?.label.isNullOrEmpty()) element.metaModel?.label else if (!element.label.isNullOrEmpty()) element.label else ""

  private fun getRandomString(): String {
    val allowedChars = ('a'..'z') + ('A'..'Z')
    return (1..8)
      .map { allowedChars.random() }
      .joinToString("")
  }
}